import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import { useCompanyId } from "@/context/CompanyContext";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { clientsKeys } from "./keys";

export interface UseClientDataGatheringOptions {
  faClientId: string;
  enabled?: boolean;
}

/** Data-gathering phase summary for one fa_client (Plans tab). */
export function useClientDataGathering({
  faClientId,
  enabled: enabledOption = true,
}: UseClientDataGatheringOptions) {
  const isWindowLive = useWindowLive();
  const companyId = useCompanyId();
  const queryEnabled = Boolean(faClientId) && enabledOption && isWindowLive;

  const query = useQuery({
    queryKey: clientsKeys.dataGathering(faClientId, companyId ?? undefined),
    enabled: queryEnabled,
    refetchOnWindowFocus: queryEnabled,
    queryFn: () => AgenticV2API.getFaClientDataGathering(faClientId),
  });

  return {
    summary: query.data ?? null,
    loading: query.isLoading,
    error: query.error,
    refresh: () => void query.refetch(),
  };
}
